// test1174
(1174 && 0);
